import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import sidebarList from './sidebar.json';
import useHasVirtualBatteries from '../../hooks/batteries/useHasVirtualBatteries';
import '../../../node_modules/font-awesome/css/font-awesome.min.css';

const SideNavbar = props => {
    let url = props.location.pathname;
    const routes = props.availableRoutes.reduce((routes, route) => {
        routes[route.path] = route.allowedRoles;
        return routes;
    }, {});

    // Only the few retailers with a virtual battery see the battery items; everyone else
    // would land on an empty page. Only the menu is gated, not the routes: gating the
    // routes on an async answer would bounce deep links through the "/" redirect before
    // it arrives. The rail stays mounted across navigation, so this is one call a session.
    const hasVirtualBatteries = useHasVirtualBatteries(
        sidebarList.some(element => element.requires === 'virtualBatteries' && routes.hasOwnProperty(element.link))
    );

    const sidebarElements = sidebarList.reduce((elements, element) => {
        if (element.requires === 'virtualBatteries' && hasVirtualBatteries !== true) {
            return elements;
        }
        if (routes.hasOwnProperty(element.link)) {
            element['allowedRoles'] = routes[element.link];

            // The rail is collapsed to icons until hover, so a badged item needs
            // both halves: a dot on the icon that is always visible, and the
            // label itself once there is room for text. The icon is only wrapped
            // when badged, so every other item's markup is untouched.
            const icon = <img src={`/assets/icons/${element.iconName}`} className="icon" alt={element.iconAlt} title={element.title} />;

            elements.push(
                <Fragment key={element.link}>
                    <li className={url === element.link ? 'sidebar__list--item-active' : 'sidebar__list--item'}>
                        <NavLink exact to={element.link} className="sidebar__list--link">
                            {element.badge ? <span className="sidebar__list--link--icon-wrap">{icon}</span> : icon}
                            <span className="sidebar__list--link--title medium">{element.title}</span>
                            {element.badge && <span className="sidebar__list--link--badge">{element.badge}</span>}
                        </NavLink>
                    </li>
                </Fragment>
            );
        }

        return elements;
    }, []);

    return (
        <div className="sidebar">
            <ul className="sidebar__list">{sidebarElements}</ul>
        </div>
    );
};

export default withRouter(SideNavbar);
